import { ICurrency } from "@/entity/shared/ICurrencyTypes";
import { vxm } from "@/store";

export function formatCurrencyByProject(value: number, options?: Intl.NumberFormatOptions) {
    const label = vxm.project.dropdownProject?.entity.currency?.code;
    return formatCurrency(value, label, options);
}

export default function formatCurrency(value: number, currencyCode?: ICurrency["code"], options?: Intl.NumberFormatOptions){
    switch (currencyCode) {
        case 'CAD':
            return new Intl.NumberFormat('fr-CA', { style: 'currency', minimumFractionDigits: 2, currency: 'CAD', ...options}).format(value);
        case 'EUR':
        default:
            return new Intl.NumberFormat('fr-FR', { style: 'currency', minimumFractionDigits: 2, currency: 'EUR', ...options}).format(value);
    } 
}